
  var newsletter_popup = {
    init: function() {
      var popup = Cookies.get('popup');
      var days = 2;

      var cookie_enabled = days && days != '0';
      if (cookie_enabled && popup === 'open') {
        return false;
      } else {
        newsletter_popup.open();
      }

      if (cookie_enabled) {
        Cookies.set('popup', 'open', { expires: days });
      }
    },

    open: function() {
      var mobile_cookie = false;
      var pop_sec = 0;

      if (mobile_cookie || $(window).width() > 798) {
        setTimeout(function() {
          if ($('.js-newsletter-popup').length) {
            $.fancybox.open($('.js-newsletter-popup'), {
              baseClass: 'newsletter__lightbox',
              hash: false,
              infobar: false,
              toolbar: false,
              loop: true,
              smallBtn: true,
              mobile: {
                preventCaptionOverlap: false,
                toolbar: true,
                buttons: ["close"]
              }
            });
          } else {
            console.warn("Newsletter popup element not found.");
          }
        }, pop_sec ? pop_sec * 1000 : 2000);
      }
    }
  };

  // Run the popup initializer after DOM is ready
  $(document).ready(function() {
    newsletter_popup.init();
  });